import Button from '@/components/Button';
import Text from '@/components/Text';
import type { Industry } from '@/services/resume-checker';

import ApplyReviewDialog from './ApplyReviewDialog';

type Props = {
  offerLink: string;
  isDeprecated: boolean;
  industry?: Industry;
};

const ApplyButton = ({ offerLink, isDeprecated, industry }: Props) => {
  if (isDeprecated) {
    return (
      <Button
        variant="candidate-black"
        size="candidate-md"
        disabled
        className="cursor-not-allowed opacity-40"
      >
        No longer accepting applications
      </Button>
    );
  }

  return (
    <ApplyReviewDialog offerLink={offerLink} industry={industry}>
      <Button
        tabIndex={-1}
        variant="candidate-black"
        suffixIcon="material-symbols-light:open-in-new"
        size="candidate-md"
      >
        <Text>Apply now</Text>
      </Button>
    </ApplyReviewDialog>
  );
};

export default ApplyButton;
